// Values already used across the mobile WebView. Platform unit guidance lives in DESIGN.md.
export const FONT_FAMILY = '"Pretendard", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

export const colors = {
    brand: '#ffe566',
    brandLight: '#ffed9e',
    brandHover: '#e8d040',
    brandText: '#5a4a00',
    brandDark: '#8a7000',
    canvas: '#f5f5f5',
    surface: '#ffffff',
    surfaceMuted: '#f9fafb',
    text: '#1a1a1a',
    textSecondary: '#666666',
    textMuted: '#999999',
    border: '#eef2f7',
    borderNeutral: '#f0f0f0',
    disabled: '#e5e7eb',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
};

export const shape = {
    controlRadius: 12,
    cardRadius: 12,
    controlMinHeight: 48,
    fieldMinHeight: 52,
};

// Bottom-sheet spacing is shared by common and standalone panels.
export const sheetSpacing = {
    horizontal: '20px',
    section: '16px',
    action: '20px',
    bottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)',
    maxWidth: 480,
};

// Match the native privacy sheet, including the real Pretendard ExtraBold face.
export const settingsSheetTitle = {
    fontSize: '1.16rem',
    fontWeight: 800,
    lineHeight: 1.5,
    letterSpacing: '0.15px',
    color: colors.text,
    textAlign: 'center',
};
